import { VuexHelper } from '@amarkets/atlas/esm/lib/vuex-helper';
import createActions from './actions';
import state from './state';
import mutations from './mutations';
import getters from './getters';

export default function (context) {
  return VuexHelper.createStoreModule({
    states: [state],
    actions: [createActions(context)],
    mutations: [mutations],
    getters: [getters],
  });
}
